<button
  (click)="handleRemoveClick()"
  class="absolute -top-4 -right-4 flex size-8 items-center justify-center rounded-full bg-gray-100 px-0">
  <app-icon [icon]="Icon.X_LG" />
</button>
